/**
 * 官网配置
 */

export default {
  local: {// 本地
    httpRoot: 'http://local.api.blissmall.net',
    baiduMap: 'http://api.map.baidu.com'
  },
  dev: {// 开发
    httpRoot: '/local',
    // baiduMap: '/baiduMap',
    baiduMap: 'http://api.map.baidu.com'
  },
  qa: {// 测试

  },
  prod: {// 生产
    httpRoot: '//api.blissmall.net',
    baiduMap: '//api.map.baidu.com'
  },
  prodWx: {// 生产
    httpRoot: '//api.blissmall.net',
    baiduMap: '//api.map.baidu.com'
  },
  qa002: {// 测试
    httpRoot: 'http://qa002.api.blissmall.net',
    baiduMap: 'http://api.map.baidu.com'
  },
  qa001: {// 测试
    httpRoot: 'http://qa001.api.blissmall.net',
    baiduMap: 'http://api.map.baidu.com'
  },
  qa003: {// 测试
    httpRoot: '//qa003.api.blissmall.net',
    baiduMap: '//api.map.baidu.com'
  }

}



// WEBPACK FOOTER //
// ./src/config/index.js